import dayjs from 'dayjs';
import id from 'dayjs/locale/id';
import { DateFormat, dateFormat } from './dataFormat';

export const renderDate = (
  date: Date | string,
  type: DateFormat | string,
  locale?: string
) => {
  if (locale === 'en') {
    switch (type) {
      case 'date':
        return dayjs(date).format(dateFormat(type));
      case 'datetime':
        return dayjs(date).format(dateFormat(type));
      case 'dateyear':
        return dayjs(date).format(dateFormat(type));
      case 'datetimeyear':
        return dayjs(date).format(dateFormat(type));
      case 'time':
        return dayjs(date).format(dateFormat(type));
      default:
        return dayjs(date).format(type);
    }
  }
  switch (type) {
    case 'date':
      return dayjs(date).locale(id).format(dateFormat(type));
    case 'datetime':
      return dayjs(date).locale(id).format(dateFormat(type));
    case 'dateyear':
      return dayjs(date).locale(id).format(dateFormat(type));
    case 'datetimeyear':
      return dayjs(date).locale(id).format(dateFormat(type));
    case 'time':
      return dayjs(date).locale(id).format(dateFormat(type));
    default:
      return dayjs(date).locale(id).format(type);
  }
};

export const dateToISOString = (date: string) => {
  return dayjs(date).toISOString();
};
